import type { SVGProps } from "react";
import * as React from "react";

export const TrashIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className="fill-current"
    {...props}
  >
    <g
      fill="currentColor"
      clipPath="url(#trash_svg__a)"
    >
      <path d="M8.294 12.335a.912.912 0 1 1-1.823 0V7.1a.912.912 0 1 1 1.823 0zM11.44 12.335a.912.912 0 1 1-1.823 0V7.1a.912.912 0 1 1 1.824 0z" />
      <path d="M15.61 4.092a.5.5 0 0 0-.12-.336.25.25 0 0 0-.188-.093h-4.138l-.616-1.311-.02-.04a.4.4 0 0 0-.13-.155.33.33 0 0 0-.19-.048H7.796a.3.3 0 0 0-.175.047.6.6 0 0 0-.177.221L6.84 3.663H2.7a.25.25 0 0 0-.188.093.5.5 0 0 0-.12.336c0 .356.036.596.094.737a.4.4 0 0 0 .03.06q.011.014.012.014.003.002.019.007a1.4 1.4 0 0 1 .55.232c.363.253.602.672.621 1.202l.809 8.72.001.013.001.014c.029.452.4.8.854.8h7.24c.452 0 .825-.35.854-.8v-.014l.002-.014.808-8.719c.02-.51.256-.891.544-1.129a1.5 1.5 0 0 1 .581-.296l.01-.002.004-.001h.003c-.004.006.07-.014.07-.014l.012-.028c.063-.156.1-.423.1-.782M2.257 6.854h.005-.007zm15.32-2.762c0 .424-.034.997-.239 1.51-.181.457-.53.926-1.113 1.141l-.788 8.502a2.823 2.823 0 0 1-2.816 2.614h-7.24a2.82 2.82 0 0 1-2.816-2.615l-.79-8.52C1.213 6.488.86 6.051.664 5.578.456 5.073.422 4.52.422 4.092c0-1.24.935-2.398 2.277-2.398h2.89l.085-.18.008-.017.009-.017C6.083.723 6.796.14 7.795.14h2.414c.941 0 1.684.513 2.083 1.296l.037.077.085.18h2.888c1.34 0 2.276 1.16 2.276 2.4" />
    </g>
    <defs>
      <clipPath id="trash_svg__a">
        <path
          fill="currentColor"
          d="M0 0h18v18H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
